import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { BaseIconComponent } from '../../private/base-icon/base-icon.component';

@Component({
  selector: 'icon-cancel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cancel-icon.component.html',
  styleUrls: ['../styles.scss'],
})
export class CancelIconComponent extends BaseIconComponent {}
